import './Mobile.css'

export const Mobile = () => {
    return (
        <div className="mobile">
            <img src="./assets/Images/Logo.webp" alt="Day Of Impression" />
            <h1>Sorry, this experience is not available on mobile devices</h1>
            <p>Go back to <a href="https://dayofimpressions.fr">dayofimpressions.fr</a></p>
        </div>
    );
};